import firebase from 'firebase/app';
import 'firebase/database'
import 'firebase/auth';

const config = {
    apiKey: "AIzaSyDl2eVgB3zN7_LjLjEqtJr227CV1OFyXOo",
    authDomain: "react-spas-344b4.firebaseapp.com",
    databaseURL: "https://react-spas-344b4.firebaseio.com",
    projectId: "react-spas-344b4",
    storageBucket: "",
    messagingSenderId: "961126980331",
    appId: "1:961126980331:web:d1c524d9cad32d6b"
  };
  // Initialize Firebase
  firebase.initializeApp(config);

  export const provider = new firebase.auth.GoogleAuthProvider();
  export const auth = new firebase.auth();

  export default firebase;